// Chat time formatting (#529) — sidebar relative stamps, thread day separators.
// `now` is injectable so the boundary math is unit-testable (see chatTime.test.ts).

export function relativeTime(iso: string, now: number = Date.now()): string {
  const ms = now - new Date(iso).getTime();
  if (ms < 60_000)         return 'Just now';
  if (ms < 3_600_000)      return `${Math.floor(ms / 60_000)}m`;
  if (ms < 86_400_000)     return `${Math.floor(ms / 3_600_000)}h`;
  if (ms < 7 * 86_400_000) return new Date(iso).toLocaleDateString([], { weekday: 'short' });
  return new Date(iso).toLocaleDateString([], { month: 'short', day: 'numeric' });
}

export function shortTime(iso: string): string {
  return new Date(iso).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export function dayLabel(iso: string, now: Date = new Date()): string {
  const d         = new Date(iso);
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (d.toDateString() === now.toDateString())       return 'Today';
  if (d.toDateString() === yesterday.toDateString()) return 'Yesterday';
  const daysDiff = (now.getTime() - d.getTime()) / 86_400_000;
  if (daysDiff < 7) return d.toLocaleDateString([], { weekday: 'long' });
  return d.toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric' });
}

// YYYY-MM-DD boundary detection for date separators between messages.
export function isoDay(iso: string): string {
  return iso.slice(0, 10);
}
